import React from 'react';
import { EnvelopeIcon } from '@heroicons/react/24/outline';

const KlaviyoAnalytics = () => (
  <div className="p-6">
    <h1 className="text-2xl font-semibold text-gray-900">Klaviyo Analytics</h1>
    <div className="mt-8 flex flex-col items-center justify-center rounded-lg border border-dashed border-gray-300 bg-white px-6 py-16 text-center">
      <EnvelopeIcon className="h-10 w-10 text-gray-400" aria-hidden="true" />
      <p className="mt-4 text-sm font-medium text-gray-700">Klaviyo Analytics is coming soon.</p>
      <p className="mt-1 text-sm text-gray-500">
        Edit access on this view also lets KIP publish email templates to Klaviyo on your behalf.
      </p>
    </div>
  </div>
);

export default KlaviyoAnalytics;
